import { useState } from 'react';
import { toast } from 'react-toastify';
import useAuthRequest from '../services/requests.service';

export const useImageUpload = () => {
    const [isUploading, setIsUploading] = useState(false);
    const { postDataAPIWithoutToken } = useAuthRequest();

    const uploadImage = async (file) => {
        if (!file) return null;

        setIsUploading(true);
        try {
            const formData = new FormData();
            formData.append('image', file);
            
            const res = await postDataAPIWithoutToken('uploadImage', formData);
            return res.uploadLocation;
        } catch (error) {
            console.error('Image upload failed:', error);
            toast.error("Erreur lors de l'upload de l'image");
            return null;
        } finally {
            setIsUploading(false);
        }
    };

    return { uploadImage, isUploading };
};